import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAllMarketSelected: false, // ✅ Default state (false means not selected)
};

const allMarketSlice = createSlice({
  name: "allMarket",
  initialState,
  reducers: {
    setAllMarketSelected: (state, action) => {
      state.isAllMarketSelected = action.payload; // ✅ Set true/false based on payload
    },
    resetAllMarket: (state) => {
      state.isAllMarketSelected = false; // ✅ Reset to default (false)
    },
  },
});

export const { setAllMarketSelected, resetAllMarket } = allMarketSlice.actions;
export default allMarketSlice.reducer;
